import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useChatPageStyles = makeStyles((theme: Theme) => ({
  contentWrapper: {
    backgroundColor:
      theme.palette?.mode === 'dark'
        ? 'var(--xlrt-color-ui-gray25)'
        : 'var(--xlrt-color-ui-white)',
    overflow: 'hidden',
    '& .bodyContainer': {
      overflowY: 'auto',
      padding: '0 1rem',
      '&::-webkit-scrollbar': {
        backgroundColor: theme.palette.background.default,
        scrollbarWidth: 'thin',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: theme.palette.background.paper,
        outline: `1px solid ${theme.palette.divider}`,
      },
      '&::-webkit-scrollbar-thumb': {
        maxWidth: '4px',
        backgroundColor: theme.palette.grey[500],
        borderRadius: '10px',
        border: `2px solid ${theme.palette.background.paper}`,
      },
    },
  },
  bodyContainer: {
    display: 'flex',
    height: '100%',
  },
  chatContainer: {
    flex: 1,
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    position: 'relative',
  },
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: '20px',
  },
}));
